import './Banner.css';
import Form, { FormProps } from '..';
import useStore from '../../Hooks/useStore';
import { useEffect } from 'react';
import Element from '../../Element';

interface BannerPriceProps extends FormProps {}

export default function BannerPrice({
  children,
  className = '',
  ...rest
}: BannerPriceProps) {
  const [getters, setters] = useStore();
  const {
    form: { getElements },
    banner: { getBanner },
  } = getters;

  const {
    form: { setBatchForm },
    banner: { setBanner, updateUserSiganature },
  } = setters;

  const elements = getElements('price');
  const signature = getBanner('signature');

  useEffect(() => {
    updateUserSiganature();
  }, [signature]);
  
  return (
    <Form.Banner
      className={`form-banner ${className}`}
      onSubmit={(e: any) => {
        e.preventDefault();
      }}
      {...rest}
    >
      <Element elements={elements} />

      <Form.Input
        className="form-banner-field"
        errorMessage={false}
        value={signature}
        onChange={(e) => {
          const value = e.target.value;
          setBanner({
            field: 'signature',
            value,
          });
          setBatchForm('config.signature', value);
        }}
        label="Identificação"
      />
    </Form.Banner>
  );
}
